export default __webpack_public_path__ + "static/media/ABSecNew1.db1b8e18.svg";